import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Helmet } from "react-helmet";
import { useUser } from "~/Context/userContext";

import "../../css/tracks.less";
import "../../css/MessageBoard.less";
import MessageBoardContainer from "../../Containers/MessageBoardContainer";

import "./MessageBoardPage.less";
import MessageBoardFooter from "./MessageBoardFooter";
import MessageBoardSearchForm from "./MessageBoardSearchForm";
import { Redirect } from "react-router-dom";
import MessageBoardHeader from "./MessageBoardHeader";
import MessageBoardRightNav from "../../Components/Elements/Global/RightNav";
import Kba from "../../Components/Elements/Kba";

function MessageBoardPage(props) {
  const { state: userState } = useUser();

  const [refresh, setRefresh] = useState(false);
  const [terms, setTerms] = useState("");
  const [redirect, setRedirect] = useState(false);
  const [page, setPage] = useState((props.match && parseInt(props.match.params.page, 10)) || 1);

  useEffect(() => {
    const pageParam = (props.match && props.match.params && props.match.params.page) || 1;
    const nextPage = parseInt(pageParam, 10);
    if (nextPage !== page) {
      setPage(nextPage);
    }
  }, [props.match]);

  useEffect(() => {
    if (page === 1 && refresh) setRefresh(false);
  }, [page, refresh]);

  const setSearchRedirect = (terms) => {
    setRedirect(true);
    setTerms(terms);
  };

  const renderSearchRedirect = () => {
    if (redirect) {
      return <Redirect to={`/message-board/search?terms=${terms}`} />;
    }
  };

  const checkRecent = () => {
    // page refresh here
    setPage(1);
    setRefresh(true);
  };

  const prevPage = page ? page - 1 : 1;
  const nextPage = page ? page + 1 : 2;

  return (
    <div className="page-message-board">
      {renderSearchRedirect()}
      <Helmet>
        <title>Message Board : Track of the Day | Dream Chimney</title>
      </Helmet>
      <MessageBoardHeader checkRecent={checkRecent}>
        Most Recent Topics <span className="subhead-page">{page > 1 ? `(Page ${page})` : null}</span>
      </MessageBoardHeader>
      <Row>
        <Col xs={12} sm={12} md={12} lg={9}>
          <div className="totd-box">
            <Row noGutters={true}>
              <Col xs={12} sm={10} lg={8} className="totd-mb-title">
                Most Recent Topics
              </Col>
              <Col xs={12} sm={0} md={3} lg={3} className="d-md-none d-lg-block totd-mb-title hide-mobile">
                Last posted by
              </Col>
              <Col sm={2} lg={1} className="totd-mb-title mb-title-replies hide-mobile">
                Replies
              </Col>
            </Row>
            <MessageBoardContainer
              page={page}
              refresh={refresh}
              render={({ topics }) => (
                <div>
                  {topics.map((topic) => (
                    <Row key={topic.thread_id} className="totd-mb-row">
                      <Col xs={12} sm={10} md={9} lg={8}>
                        {topic.unread_msgs && userState.loggedin && userState.isChim && (
                          <img src="/tracks/img/totd-mb-thread-new.gif" className="mb-icon-new" border="0" alt="New Post to this Topic" />
                        )}
                        <Link to={`/message-board/topic/${topic.thread_id}`}>
                          {topic.subject !== "" && topic.subject}
                          {topic.subject === "" && (
                            <span>
                              "{topic.title}" by {topic.artist}
                            </span>
                          )}
                        </Link>
                      </Col>
                      <Col xs={12} sm={0} md={2} lg={3}>
                        {topic.display_name}
                      </Col>
                      <Col sm={2} md={1} lg={1} className="hide-mobile">
                        {topic.replies}
                      </Col>
                    </Row>
                  ))}
                  <Row className="totd-mb-footer">
                    <Col xs={12} sm={6}>
                      <div className="">
                        {prevPage > 0 && (
                          <div className="totd-mb-pagination-link">
                            <Link className="pagination pagination-item" to={`/message-board/page/${prevPage}`}>
                              Previous
                            </Link>
                          </div>
                        )}
                        {nextPage !== 0 && (
                          <div className="totd-mb-pagination-link">
                            <Link className="pagination pagination-item" to={`/message-board/page/${nextPage}`}>
                              Next
                            </Link>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col xs={12} sm={6}>
                      <MessageBoardSearchForm doSearch={setSearchRedirect} />
                    </Col>
                  </Row>
                </div>
              )}
            />
          </div>
          <Col xs={12}>
            <Kba />
          </Col>
        </Col>
        <Col xs={12} sm={12} md={12} lg={3}>
          <MessageBoardRightNav />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {/* <ins
              class="epn-placement"
              style={{ display: "inherit", textAlign: "center", marginTop: "20px" }}
              data-config-id="5c9ef527cdf6ce4121db1c46"
            ></ins> */}
          <MessageBoardFooter />
        </Col>
      </Row>
    </div>
  );
}

export default MessageBoardPage;
